import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, ArrowRight } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/parent/password/request-reset", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16 md:py-24">
      <div className="w-14 h-14 rounded-2xl bg-[#FFBF69]/25 grid place-items-center text-[#B36906]"><KeyRound className="w-6 h-6" /></div>
      <h1 className="mt-6 font-display font-black text-4xl tracking-tight">Reset password</h1>
      <p className="mt-3 text-[#7A7D8C]">Enter your email and we'll send you a link to choose a new password.</p>

      {sent ? (
        <div className="mt-8 rounded-2xl bg-[#2EC4B6]/10 border border-[#2EC4B6]/30 p-6" data-testid="forgot-sent">
          <div className="font-display font-bold text-lg text-[#0F7A72]">Check your inbox</div>
          <p className="mt-2 text-sm text-[#1E1E24]">If an account exists for <b>{email}</b>, we've sent a reset link that expires in 2 hours.</p>
          <Link to="/signin" className="mt-4 inline-block text-sm font-semibold text-[#FF9F1C]">Back to sign in →</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 bg-white rounded-3xl border border-slate-100 p-6 space-y-4" data-testid="forgot-form">
          <div>
            <label className="text-xs uppercase tracking-wider font-semibold text-[#7A7D8C]">Email</label>
            <input data-testid="forgot-email" type="email" value={email} required onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-xl border border-slate-200 bg-[#FDFFFC] px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9F1C]" />
          </div>
          <button disabled={busy} type="submit" data-testid="forgot-submit" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#FF9F1C] text-white font-bold shadow-[0_12px_30px_rgb(255,159,28,0.35)] disabled:opacity-60">
            {busy ? "Sending…" : "Send reset link"} <ArrowRight className="w-4 h-4" />
          </button>
          <p className="text-xs text-[#7A7D8C] text-center"><Link to="/signin" className="text-[#FF9F1C] font-semibold">Back to sign in</Link></p>
        </form>
      )}
    </div>
  );
}
